import { FaPlus } from "react-icons/fa";

export default function AddBtn({ onClick, label }) {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 text-white font-medium rounded-lg bg-blue-500 hover:bg-blue-600 inline-flex items-center gap-2"
    >
      {label}
      <FaPlus className="w-3 h-3" />
    </button>
  );
}
